export default __webpack_public_path__ + "static/media/icon_management.ca3ac97d.svg";